// components/DomainSwitch.js
import React from 'react';

const TABS = [
  { val: 'toshba', label: 'מסלול תושב"ע 5291' },
  { val: 'talmud', label: 'מסלול תלמוד 6281'  },
];

export function visibleDomains(tractate) {
  const domains = [];
  if (!tractate) return ['toshba', 'talmud'];
  if (tractate.toshba_visible !== false) domains.push('toshba');
  if (tractate.talmud_visible !== false) domains.push('talmud');
  return domains;
}

export function pickVisibleDomain(requested, tractate) {
  const vis = visibleDomains(tractate);
  const req = String(requested || '').toLowerCase();
  if (vis.includes(req)) return req;
  return vis[0] || null;
}

export default function DomainSwitch({ value = 'toshba', onChange, domains }) {
  const select = (v) => { if (typeof onChange === 'function') onChange(v); };
  const tabs = TABS.filter(({ val }) => !domains || domains.includes(val));

  if (tabs.length <= 1) return null;

  return (
    <div
      className="inline-flex rounded-xl bg-secondary-100 dark:bg-secondary-800 p-1"
      role="tablist"
      aria-label="בחירת תחום"
    >
      {tabs.map(({ val, label }) => (
        <button
          key={val}
          type="button"
          role="tab"
          aria-selected={value === val}
          onClick={() => select(val)}
          className={[
            'px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 border-0 cursor-pointer',
            value === val
              ? 'bg-white dark:bg-secondary-700 text-primary-600 dark:text-primary-400 shadow-soft'
              : 'bg-transparent text-secondary-600 dark:text-secondary-400 hover:text-secondary-900 dark:hover:text-white',
          ].join(' ')}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

